module.exports = __webpack_public_path__ + "img/12.a1b3b0b7.png";